module.exports = __webpack_public_path__ + "fonts/Inter-400-vietnamese47.9df1755.woff2";